export default {
  namespaced: true,
  state: {
    processoSelecionado: null,
  },
  getters: {
    getProcessoSelecionado(state) {
      return state.processoSelecionado;
    },
  },
  mutations: {
    setProcessoSelecionado(state, processos) {
      state.processoSelecionado = processos;
    },
  },
  actions: {},
};
